module.exports = __webpack_public_path__ + "assets/img/successIcon.07144ea8.svg";